import { api } from "@/forms/api";
import { getPreRegTrackingPageData } from "@/forms/preRegTrackingData";

let isRegistered = false;
let lastOptanonConsent = getCookie("OptanonConsent");

function getCookie(name: string) {
  const value = document.cookie
    .split("; ")
    .find(cookie => cookie.indexOf(`${name}=`) === 0);

  return value ? value.substring(name.length + 1) : null;
}

function trackCookieConsentUpdated() {
  const currentOptanonConsent = getCookie("OptanonConsent");

  if (currentOptanonConsent === lastOptanonConsent) {
    return;
  }

  lastOptanonConsent = currentOptanonConsent;

  api.forms
    .preRegTracking({
      event: "cookie_consent_updated",
      data: getPreRegTrackingPageData()
    })
    .catch(() => {});
}

function registerOneTrustConsentTracking() {
  const oneTrust = (<any>window).OneTrust;

  if (
    isRegistered ||
    !oneTrust ||
    typeof oneTrust.OnConsentChanged !== "function"
  ) {
    return;
  }

  isRegistered = true;

  oneTrust.OnConsentChanged(function() {
    window.setTimeout(trackCookieConsentUpdated, 0);
  });
}

window.addEventListener("oneTrustLoaded", registerOneTrustConsentTracking);
registerOneTrustConsentTracking();
